import { WishlistsQuery } from "@apps/wishlist/queries/WishlistsQuery";
import { map, Observable } from "rxjs";

import { WishlistSdkDto } from "../types";
import { mapWishlistToSdkDto } from "../utils/mapWishlistToSdkDto";

export class WishlistsStackQueryWrapper {
    constructor(private readonly wishlistsQuery: WishlistsQuery) {}

    selectAll(): Observable<WishlistSdkDto[]> {
        return this.wishlistsQuery
            .selectAll()
            .pipe(map((wishlists) => wishlists.map(mapWishlistToSdkDto)));
    }

    selectEntity(id: number): Observable<WishlistSdkDto | undefined> {
        return this.wishlistsQuery.selectEntity(id).pipe(
            map((wishlist) => {
                if (!wishlist) return undefined;
                return mapWishlistToSdkDto(wishlist);
            })
        );
    }

    selectFirst(): Observable<WishlistSdkDto | undefined> {
        return this.wishlistsQuery.selectFirst().pipe(
            map((wishlist) => {
                if (!wishlist) return undefined;
                return mapWishlistToSdkDto(wishlist);
            })
        );
    }
}
